import * as angular from 'angular';

import { Logger } from '@mode/shared/contract-common';
import SpaceMembershipController from '../space-membership/space-membership-component';
import template from '../space-membership/space-membership.html';

class GroupMembershipController extends SpaceMembershipController {
  static $inject = [
    '$scope',
    '$log',
    'SearchClientService',
    'SpaceMembershipModel',
    'ToastService',
    'GroupMembershipModel',
  ];

  public group: any;
  public owner: any;

  constructor(
    public $scope,
    public $log: Logger,
    public searchClientService,
    public SpaceMembershipModel,
    public AlertService,
    public GroupMembershipModel
  ) {
    super($scope, $log, searchClientService, SpaceMembershipModel, AlertService);
  }

  getMemberships() {
    return this.group.groupMemberships({ includes: { group_memberships: 'member' } });
  }

  getMembershipModel() {
    return this.GroupMembershipModel;
  }

  // override so current user membership is actionable
  isCurrentUser(account) {
    return function (user) {
      return 0;
    };
  }

  createMembership(member) {
    return this.GroupMembershipModel.create({
      group: this.group.token,
      params: {
        'membership.member_token': member.token,
        includes: ['member'],
      },
    });
  }

  getSearchOptions() {
    return {
      indexes: ['userEmail'],
      perPage: 20,
      filters: {
        userEmail: `organization_${this.owner.token},organization_${this.owner.token}_active`,
        group: '',
      },
    };
  }

  getMembersFromResponse(response) {
    // only registered users
    return response.userEmail.filter((u: any) => u.username);
  }

  insertMembershipModel(model) {
    this.GroupMembershipModel.putLocal(model);
  }
}

const GroupMembershipComponent: angular.IComponentOptions = {
  bindings: {
    group: '<',
    owner: '<',
    account: '<',
  },
  template: template,
  controller: GroupMembershipController,
  controllerAs: 'ctrl',
};

angular.module('mode.components').component('groupMembership', GroupMembershipComponent);
